/**
 * Survey
 */

import './elements/progress-ring.js';

(function($) {

    if ( typeof vous_l10n === 'undefined' ) { // Ensure l10n is set
        return;
    }
    if ( typeof vous_l10n.survey_form_id === 'undefined' || ! vous_l10n.survey_form_id ) { // Ensure script is enabled
        return;
    }

    // Triggers when page is loaded
    $(document).on('gform_page_loaded', function(event, form_id, current_page) {
        if ( form_id != vous_l10n.survey_form_id ) { // Apply only to the survey form
            return;
        }

        const $page = $('.js-survey-page-finish');
        if ( $page.filter(':visible').length == 0 ) { // Apply only to the finish page
            return;
        }

        const $block = $page.find('.survey-finish');
        setTimeout(() => {
            $block.find('.survey-finish__heading').fadeOut(200, () => {
                $block.find('.survey-finish__progress').fadeIn(200, () => {
                    let progress = 0;
                    const enough = 97; // Percentage that is enough to submit the form and begin loading the results page
                    const ring = document.querySelector('progress-ring');
                    const $captions = $block.find('.survey-finish__ring-captions').children();
                    const loop = function () {
                        $captions.each(function () {
                            let $this = $(this);
                            if ( $this.data('progress') <= progress ) {
                                $this.show(0).siblings().hide(0);
                            }
                        });                            
                        let amount = Math.round( Math.random() * 10 );
                        if ( progress < enough ) {
                            setTimeout(() => {
                                progress = (progress + amount < 100) && progress + amount || 100;
                                ring.setAttribute('progress', progress);
                                loop();
                            }, 250);
                        } else {
                            $page.closest('form').trigger('submit', [true]);
                        }
                    };
                    loop();
                });
            });
        }, 2000);
    });

})(jQuery);
